const Error = () => (
    <div className="w-full h-full min-h-[75vh]">
        <div className="flex flex-col px-16 py-48 space-y-2">
            <h1 className="font-BreezeMono font-bold text-6xl">404</h1>
            <h2 className="font-BreezeHeader font-bold text-4xl">Page not found</h2>
        </div>
    </div>
);

export default Error;